import { Item } from "./Item";
import { S25WsNode } from "./S25WsNode";
import { S25ItemI } from "./S25ItemI";
import { Proto } from "./Proto";
import { DropDownItem } from "./DropDownItem";
import NumericalBoolean = Proto.NumericalBoolean;
import ServiceStatus = Proto.ServiceStatus;
import { CustomAttributes } from "./CustomAttributes";

export namespace Contact {
    export interface ItemData {
        subject: "contact";
        id: Item.Ids.Contact;
    }

    export interface Data {
        contactId: number;
        email: string;
        etag: string;
        familyName: string;
        firstName?: string;
        isFavorite: boolean;
    }

    export interface DataI extends S25WsNode {
        contact_email: string;
        contact_first_name: string;
        contact_formatted_address: string;
        contact_id: number;
        contact_last_name: string;
        contact_name: string;
        contact_role: string;
        contact_role_id: number;
        primary_contact: "T" | "F";
    }

    export interface Organization extends S25WsNode {
        organization_id: number;
        organization_name: string;
        role_id: number;
        role_name: string;
    }

    export interface ContactRoleI extends S25WsNode {
        contact: Contact.DataI[];
        role_id: number;
        role_name: string;
        role_sort_order: number;
    }

    export type DetailData = {
        // used for object details component
        general: {
            contactName: string;
            firstName: string;
            middleName: string;
            lastName: string;
            namePrefix: string;
            nameSuffix: string;
            title: string;
            internalId: number;
        };
        userAccount: {
            userName: string;
            active: NumericalBoolean;
            securityGroup: DropDownItem | null;
        };
        comments: string;
        attributesEditable: CustomAttributes.CustAttrObj[];
        editableOrgs: (S25ItemI & { role: S25ItemI; status?: ServiceStatus })[];
        editableHomeAddress: EditableAddress;
        editableWorkAddress: EditableAddress;
    };

    type EditableAddress = {
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        phone: string;
        fax: string;
        email: string;
        addressType: AddressType;
    };

    export enum AddressType {
        Work = 3,
        Home = 4,
    }

    export namespace Role {
        export namespace Event {
            export const id = {
                Instructor: -3,
                Scheduler: -2,
                Requestor: -1,
            } as const;
        }

        export namespace Location {
            export const id = {
                Scheduler: -2,
            } as const;
        }

        export namespace Organization {
            export const id = {
                Scheduler: -2,
            } as const;
        }
    }
}
